import classNames from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Col, Collapse, Row } from 'react-bootstrap';
import { FiCheck } from 'react-icons/fi';
import { withHandlers, withStateHandlers } from 'recompose';
import { compose } from 'redux';
import { Icon } from '../..';
import { AdminTaskStatus } from '../../../../constants';
import ToggleBox from '../../toggle-box';

const StatusFilter = ({
  onStatusChange,
  toggleFilter,
  showFilter,
  taskStatus
}) => {
  return (
    <div className='filter task-status-filter'>
      <Row className='button-gutter'>
        <Col xs={12}>
          <h2
            className='flexbox'
            type='button'
            onClick={toggleFilter}
            aria-expanded={showFilter}
            aria-controls='filter'>
            {
              showFilter ?
                <Icon icon='minus-large'></Icon> :
                <Icon icon='plus-large'></Icon>
            }
            <span id='label'>Status</span>
          </h2>
        </Col>
      </Row>
      <Row className='no-gutter'>
        <Collapse id='status-filter' in={showFilter}>
          <div>
            <form id='selection-list'>
              <div>
                {
                  fp.flow(
                    fp.map(
                      ({ label, selected }) => {
                        const boxLabel = selected ? <FiCheck /> : null
                        return <Row className={classNames('no-gutter flexbox align-center', { selected })} id='selection' key={label} onClick={
                          () => {
                            onStatusChange(label)
                          }
                        }>
                          <span id='checkbox'>
                            <ToggleBox
                              small
                              value={label}
                              label={boxLabel}
                              checked={selected} />
                          </span>
                          <span>{label}</span>
                        </Row>
                      }
                    )
                  )(taskStatus)
                }
              </div>
            </form>
          </div>
        </Collapse>
      </Row>
    </div>
  )
}

const getUpdatedStatus = (taskStatus, statusToToggle) => fp.flow(
  fp.map(
    (status) => ({
      ...status,
      selected: status.label === statusToToggle ? !status.selected : false
    })
  )
)(taskStatus)

export default compose(
  withStateHandlers(
    {
      showFilter: false
    },
    {
      toggleFilter: ({ showFilter }) => () => ({
        showFilter: !showFilter
      })
    }
  ),
  withStateHandlers(
    () => ({
      taskStatus: fp.flow(
        fp.values,
        fp.map(
          (status) => ({
            label: status,
            selected: false
          })
        )
      )(AdminTaskStatus)
    }),
    {
      setStatus: () => (taskStatus) => ({
        taskStatus
      })
    }
  ),
  withHandlers({
    onStatusChange: ({ onChange, setStatus, taskStatus }) => (status) => {
      const updatedStatus = getUpdatedStatus(taskStatus, status)
      setStatus(updatedStatus)
      const selectedStatus = fp.flow(
        fp.filter('selected'),
        fp.map('label')
      )(updatedStatus)
      onChange({
        status: selectedStatus
      })
    }
  })
)(StatusFilter)


// WEBPACK FOOTER //
// ./src/containers/components/filters/partials/task-status-filter.js